import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';

class OrderService extends BaseService {
    constructor() {
        super(apiroutes.ORDER);
    }

    async createOrder(data) {
        return await super.customCall('POST', '/', data, null, 'json');
    }

    async getAllOrders(params = {}) {
        return await super.customCall('GET', '/', null, params, null);
    }

    async getOrderById(id, params = {}) {
        return await super.customCall('GET', `/${id}`, null, params, null);
    }

    async updateOrderStatus(id, data) {
        return await super.customCall('PATCH', `/status/${id}`, data, null, 'json');
    }

    async updateOrderStatusById(id, status) {
        return await super.customCall('PUT', `/${id}/status`, {
            status: status
        }, null, 'json');
    }

    async cancelOrder(id) {
        return await super.customCall('DELETE', `/${id}`, null, null, 'json');
    }
}

const OrderServices = new OrderService();

export default OrderServices;
